import React from 'react';
import Reveal from './Reveal';
import './CraftProcess.css';

const steps = [
  {
    number: '01',
    title: 'Tell me about the job',
    text: 'Send a few photos, your suburb and a short description of what you have in mind. A repair, a new feature or an idea you are still working through — that is enough to start the conversation.',
  },
  {
    number: '02',
    title: 'Work through the details',
    text: 'We can discuss the scope, materials and access, and arrange a site visit where needed. Measurements, assumptions and any specialist input need to be understood before the work is priced and agreed.',
  },
  {
    number: '03',
    title: 'Get the work underway',
    text: 'Once the scope and quote are accepted, we can confirm timing, material availability and any preparations needed. Changes to the agreed work are discussed before they go ahead.',
  },
];

const CraftProcess = () => (
  <section className="craft-process" id="how-it-works" aria-labelledby="craft-process-title" data-testid="craft-process">
    <div className="craft-process__inner">
      <Reveal className="craft-process__intro">
        <p className="craft-process__eyebrow">How it comes together</p>
        <h2 className="craft-process__title" id="craft-process-title">A clear way <em>forward.</em></h2>
        <p className="craft-process__lead">A few practical steps to understand the job and agree how to approach it.</p>
        <a href="#contact" className="craft-process__link">Start a conversation <span aria-hidden="true">↗</span></a>
      </Reveal>
      <Reveal className="craft-process__steps" delay={80}>
        {steps.map((step, index) => (
          <details key={step.number} className="craft-process__step" name="craft-process-steps" open={index === 0}>
            <summary className="craft-process__summary">
              <span className="craft-process__number" aria-hidden="true">{step.number}</span>
              <h3>{step.title}</h3>
              <span className="craft-process__toggle" aria-hidden="true" />
            </summary>
            <div className="craft-process__content"><p>{step.text}</p></div>
          </details>
        ))}
      </Reveal>
    </div>
  </section>
);

export default CraftProcess;
